export const roundDealerCurrencyExchange = (value: number) => Math.round((value + 1e-10) * 100) / 100;
